import {Component, Input} from '@angular/core';

@Component({
  selector: 'progress-bar',
  standalone: false,
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.css'
})
export class ProgressBarComponent {

    @Input() label: string;
    @Input() usage: number;
    @Input() quota: number;
    @Input() progressBarColour = 'var(--zint-bear-blue)';
    @Input() numeratorLabel = "Used"
    @Input() denominatorLabel = "Assigned"

    getProgressBarValue(currentTotal: number, assignedTotal: number): number {
      if (assignedTotal === 0) return 0;
      return (currentTotal / assignedTotal) * 100;
    }

}
